export default "__VITE_ASSET__3ef971c1__"